module.exports = __webpack_public_path__ + "img/awards_image_09.0c79ee38.jpg";